import { getBudget } from "../requests/budget.ts";
import { trackError, trackIdentity } from "./mixpanel.ts";
import { AuthContextValue } from "../context/AuthContext.tsx";
import { UserResponse, User as CurrentUser } from "../types.ts";
import { createUser } from "../requests/users.ts";

export const addUser = async (
  auth: AuthContextValue,
  setCurrentUser: (val: CurrentUser) => void,
  setHasBudget: (val: boolean) => void,
) => {
  const { getAccessTokenSilently, user } = auth;

  try {
    const accessToken = await getAccessTokenSilently();

    if (user) {
      const userResponse: UserResponse =
        user.email &&
        (await createUser(accessToken, {
          email: user.email,
        }));

      setCurrentUser({
        ...user,
        ...userResponse,
      });
      setHasBudget(userResponse.hasBudget);
      trackIdentity(user.sub, user.email);
    }
  } catch (err) {
    trackError("PrivateRoute - AddUser:", { result: err });
  }
};

export const getBudgetInfo = async (
  setBudget: (val: any) => void,
  auth: AuthContextValue,
) => {
  try {
    const accessToken = await auth.getAccessTokenSilently();

    const response = await getBudget(accessToken);

    setBudget(response.budget);
  } catch (err) {
    trackError("PrivateRoute - getBudgetInfo:", { result: err });
  }
};
